import { create } from 'apisauce';

export const clmApiClient = create({
  baseURL: import.meta.env.PUBLIC_CLM_API_URL,
});

export const clmAccountApiClient = create({
  baseURL: import.meta.env.PUBLIC_CLM_ACCOUNT_API_URL,
});

export const clmUserApiClient = create({
  baseURL: import.meta.env.PUBLIC_CLM_USER_API_URL,
});

// Utility to manage headers for all API clients
const apiClients = [clmApiClient, clmAccountApiClient, clmUserApiClient];

export function setAuthHeader(header: string, value: string) {
  apiClients.forEach((client) => client.setHeader(header, value));
}

export function deleteAuthHeader(header: string) {
  apiClients.forEach((client) => client.deleteHeader(header));
}
